
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4H18L22 10L12 20L2 10L6 4Z" fill="currentColor"></path></svg>';export default svg;
    